import salesApi from '@/api/sales'

const listRegimes = [
  { sat_id: 601, description: 'General de Ley Personas Morales' },
  { sat_id: 603, description: 'Personas Morales con Fines no Lucrativos' },
  { sat_id: 605, description: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { sat_id: 606, description: 'Arrendamiento' },
  { sat_id: 607, description: 'Régimen de Enajenación o Adquisición de Bienes' },
  { sat_id: 608, description: 'Demás ingresos' },
  { sat_id: 610, description: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
  { sat_id: 611, description: 'Ingresos por Dividendos (socios y accionistas)' },
  { sat_id: 612, description: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { sat_id: 614, description: 'Ingresos por intereses' },
  { sat_id: 615, description: 'Régimen de los ingresos por obtención de premios' },
  { sat_id: 616, description: 'Sin obligaciones fiscales' },
  { sat_id: 620, description: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
  { sat_id: 621, description: 'Incorporación Fiscal' },
  { sat_id: 622, description: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
  { sat_id: 623, description: 'Opcional para Grupos de Sociedades' },
  { sat_id: 624, description: 'Coordinados' },
  { sat_id: 625, description: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
  { sat_id: 626, description: 'Régimen Simplificado de Confianza' }
]

const getDefaultState = () => ({
  list: [],
  selectedPaymentMethod: '',
  selectedSales: new Set(),
  selectedStall: '',
  selectedRegime: 0,
  selectedZipCode: '',
  invoiceWarning: false
})

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    state = getDefaultState()
  },
  SET_INVOICE_WARNING: (state) => {
    state.invoiceWarning = true
  },
  REMOVE_INVOICE_WARNING: (state) => {
    state.invoiceWarning = false
  },
  REMOVE_SELECTED_SALE: (state, saleId) => {
    state.selectedSales = new Set([...state.selectedSales].filter(id => id !== saleId))
  },
  RESET_SELECTED_PAYMENT_METHOD: state => {
    state.selectedPaymentMethod = getDefaultState().selectedPaymentMethod
  },
  RESET_SELECTED_STALL: () => {
    state.selectedStall = getDefaultState().selectedStall
  },
  SELECT_SALE: (state, saleId) => {
    state.selectedSales = new Set([...state.selectedSales]).add(saleId)
  },
  SET_SELECTED_PAYMENT_METHOD: (state, value) => {
    state.selectedPaymentMethod = value
  },
  SET_SELECTED_STALL: (state, value) => {
    state.selectedStall = value
  },
  SET_LIST: (state, list) => {
    state.list = list
  },
  UPDATE_REGIME: (state, regime) => {
    state.selectedRegime = regime
  },
  UPDATE_ZIPCODE: (state, zipcode) => {
    state.selectedZipCode = zipcode
  }
}

const actions = {
  async getSales ({ commit }) {
    commit('app/START_LOADING', '', { root: true })

    try {
      const { data } = await salesApi.getSales()

      commit('SET_LIST', data)
    } catch (error) {
      // TODO: Show error modal
    } finally {
      commit('app/FINISH_LOADING', '', { root: true })
    }
  },
  removeSelectedSale ({ commit }, saleId) {
    if (state.selectedSales.size > 1) {
      commit('REMOVE_SELECTED_SALE', saleId)

      return
    }

    commit('REMOVE_SELECTED_SALE', saleId)
    commit('RESET_SELECTED_PAYMENT_METHOD')
    commit('RESET_SELECTED_STALL')
  },
  selectSale ({ commit, state }, saleId) {
    const sale = state.list.find(sale => parseInt(sale.id) === parseInt(saleId))

    if (state.selectedSales.size > 0) {
      commit('SELECT_SALE', saleId)

      return
    }

    commit('SELECT_SALE', saleId)
    commit('SET_SELECTED_PAYMENT_METHOD', sale.payment_method)
    commit('SET_SELECTED_STALL', sale.stall)
  },
  updateSelectedRegime ({ commit, state }, regime) {
    commit('UPDATE_REGIME', regime)
  },
  updateSelectedZipcode ({ commit, state }, zipcode) {
    commit('UPDATE_ZIPCODE', zipcode)
  },
  removeInvoiceWarning ({ commit, state }) {
    commit('REMOVE_INVOICE_WARNING')
  }
}

const getters = {
  fiscalRegimes: state => {
    return listRegimes
  },
  canInvoice: state => {
    const zip = state.selectedZipCode.toString()

    return state.selectedRegime !== 0 && zip.length > 4
  },
  invoiceableSales: state => {
    return state.list
  },
  isSaleSelectable: state => saleId => {
    if (state.selectedSales.size === 0) return true

    const sale = state.list.find(sale => parseInt(sale.id) === parseInt(saleId))
    const isSamePaymentMethod = sale.payment_method === state.selectedPaymentMethod
    const isSameStall = sale.stall === state.selectedStall

    return isSamePaymentMethod && isSameStall
  },
  isSaleSelected: state => saleId => {
    return state.selectedSales.has(saleId)
  },
  invoiceWarning: state => {
    return state.invoiceWarning
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
